import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// COMPONENTS
import CardPaymentsAgreements from '@/components/Payment/CardPaymentsAgreements';

// HELP
import StripePaymentForm from '../StripePaymentForm';

const PartialPayment = props => {
  const { initialValues = {}, loading = false, disabled = false } = props;

  const [t] = useTranslation();
  const { user } = useSelector(({ auth }) => ({
    user: auth.user || {},
  }));

  return (
    <div className="m-t-15">
      <CardPaymentsAgreements label={t('subscription.payment.allowPartialPayments')} />
      <div className="m-b-30" />
      {user.card_payments_allowed && (
        <StripePaymentForm
          initialValues={initialValues}
          loading={loading}
          disabled={disabled}
          mode="addCard"
        />
      )}
    </div>
  );
};

PartialPayment.propTypes = {
  initialValues: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default PartialPayment;
